// react
import { lazy } from 'react';

import LoginLayout from 'layout/LoginLayout';
import Loadable from 'components/Loadable';

const Login = Loadable(lazy(() => import('pages/Login')));
const PasswordReset = Loadable(lazy(() => import('pages/PasswordReset')));
const PasswordResetForm = Loadable(lazy(() => import('sections/passwordReset/Form')));
const PasswordResetComplete = Loadable(lazy(() => import('sections/passwordReset/Complete')));
const PasswordChange = Loadable(lazy(() => import('pages/PasswordChange')));
const PasswordChangeForm = Loadable(lazy(() => import('sections/passwordChange/Form')));
const PasswordChangeComplete = Loadable(lazy(() => import('sections/passwordChange/Complete')));

const LoginRoutes = {
  path: 'rental',
  element: <LoginLayout />,
  children: [
    {
      path: 'login',
      element: <Login />
    },
    {
      path: 'password-reset',
      element: <PasswordReset />,
      children: [
        { path: '', element: <PasswordResetForm /> },
        { path: 'complete', element: <PasswordResetComplete /> }
      ]
    },
    {
      path: 'password-change',
      element: <PasswordChange />,
      children: [
        { path: 'complete', element: <PasswordChangeComplete /> },
        { path: ':token', element: <PasswordChangeForm /> }
      ]
    }
  ]
};

export default LoginRoutes;
